import { useState } from 'react';
import InitFilters from './ImprestFunderReport/constants/InitFiltering';
const DEFAULT_GRANT_DATA_TYPE = 'cellphoneNumber';

const useCustomHook = () => {
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewData, setPreviewData] = useState({});
  const [isOpenPreview, setIsOpenPreview] = useState(false);
  const [voucherHash, setVoucherHash] = useState('');
  const [paramsData, setParamsData] = useState(null);
  const [voucherHashs, setVoucherHashs] = useState([]);
  const [stepData, setStepData] = useState([]);
  const [fileCounter, setFileCounter] = useState(1);
  const [isShowMessageLessLevel, setIsShowMessageLessLevel] = useState(false);
  const [loadingField, setLoadingField] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [page, setPage] = useState(0);
  const [selectedCheckData, setSelectedCheckData] = useState(null);
  const [accountDetails, setAccountDetails] = useState([]);
  const [totalCount, setTotoalCount] = useState(0);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);
  const [loadingUserInfo, setLoadingUserInfo] = useState(true);
  const [userSSOid, setUserSSOid] = useState(0);
  const [isNewDialogOpen, setIsNewDialogOpen] = useState(false);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState();
  const [, setCityId] = useState();
  const [provinceId, setProvinceId] = useState();
  const [province, setProvince] = useState();
  const [guildSearchText, setGuildSearchText] = useState('');
  const [selectedGuilds, setSelectedGuilds] = useState([]);
  const [firstLoad, setFirstLoad] = useState(1);
  const [defaultProvince, setDefaultProvince] = useState(null);
  const [defaultCity, setDefaultCity] = useState(null);
  const [isShow, setIsShow] = useState(false);
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [changeOwner, setChangeOwner] = useState(false);
  const [filters, setFilters] = useState(InitFilters());
  const [filterParams, setFilterParams] = useState(null);
  const [loadingPage, setLoadingPage] = useState(false);
  // -- HOOKS --//
  const [isOpenExportDG, setIsOpenExportDG] = useState(false);
  const [isOpenTimetDG, setIsOpenTimetDG] = useState(false);
  const [timeRemain, setTimeRemain] = useState(0);
  const [isLoadingExport, setIsLoadingEport] = useState(false);
  const [isOpenTimeLineDg, setIsOpenTimeLineDg] = useState(false);
  const [dataTimeLine, setDataTimeLine] = useState(null);
  const [timeLineLength, setTimeLineLength] = useState(0);
  const [actionItems, setActionItems] = useState([
    {
      title: 'درخواست فایل خروجی با پسوند xls',
      type: 'Xls',
      status: 'offline',
    },
    {
      title: 'درخواست فایل خروجی با پسوند pdf',
      type: 'Pdf',
      status: 'offline',
    },
  ]);
  const [productSearchText, setProductSearchText] = useState('');
  const [newProductName, setNewProductName] = useState('');
  const [currentProduct, setCurrentProduct] = useState(null);
  const [size, setSize] = useState(12);
  const [loadingBtnAccept, setLoadingBtnAccept] = useState(false);
  const [loadingBtnIgnore, setLoadingBtnIgnore] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [dialog, setDialog] = useState({});
  const [methodType, setMethodType] = useState('wallet');
  const [data, setData] = useState(null);
  const [captchaId, setCaptchaId] = useState(null);
  const [captchaImg, setCaptchaImg] = useState(null);
  const [saveNumber, setSaveNumber] = useState(false);
  const [isDisable, setDisable] = useState({
    isPayaDisable: false,
    isCardDisable: false,
    isSatnaDisable: true,
  });
  const [list, setList] = useState({ card: [], sheba: [] });
  const [cardInfoAcc, setCardInfoAcc] = useState('SETTLEMENT_TOOL_PAYA');
  const [openSnack, setOpenSnack] = useState(false);
  const [show, setShow] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedValue, setSelectedValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [role, setRole] = useState();
  const [itemNeed, setItemNeed] = useState([]);
  const [blockedAccounts, setBlockedAccounts] = useState([]);
  const [inquiryAccount, setInquiryAccount] = useState('');
  const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  const [file, setFile] = useState(null);
  const [rowsWithError, setRowsWithError] = useState([]);
  const [isResultErrorsOpen, setIsResultErrorsOpen] = useState(false);
  const [userContactInfo, setUserContactInfo] = useState(null);
  const [guildCode, setGuildCode] = useState(null);
  const [foundUser, setFoundUser] = useState(null);
  const [amount, setAmount] = useState(null);
  const [description, setDescription] = useState(null);
  const [currentUserId, setCurrentUserId] = useState(null); // user checked with contact services
  const [incomingUserQuery, setIncomingUserQuery] = useState(null);
  const [blockAccounts, setBlockAccounts] = useState([]);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [grantUserDataType, setGrantUserDataType] = useState(DEFAULT_GRANT_DATA_TYPE);
  const [contactId, setContactId] = useState(null);
  // captcha fields
  const [captchaLoading, setCaptchaLoading] = useState(false);
  const [enteredCaptcha, setEnteredCaptcha] = useState('');
  const [activeDetailID, setActiveDetailID] = useState(null);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  const grantTypeOptions = [
    {
      value: 'cellphoneNumber',
      label: 'تلفن همراه',
      rules: ['isMobile'],
      englishNumber: true,
    },
    {
      value: 'userName',
      label: 'نام کاربری',
      rules: ['isUsername'],
      englishNumber: true,
    },
    {
      value: 'email',
      label: 'پست الکترونیک',
      rules: ['isEmail'],
      englishNumber: true,
    },
  ];
  return {
    currentPage, setCurrentPage,
    firstName, setFirstName,
    lastName, setLastName,
    activeDetailID, setActiveDetailID,
    file, setFile,
    enteredCaptcha, setEnteredCaptcha,
    captchaLoading, setCaptchaLoading,
    captchaImg, setCaptchaImg,
    captchaId, setCaptchaId,
    contactId, setContactId,
    grantUserDataType, setGrantUserDataType,
    isConfirmModalOpen, setIsConfirmModalOpen,
    incomingUserQuery, setIncomingUserQuery,
    currentUserId, setCurrentUserId,
    description, setDescription,
    amount, setAmount,
    foundUser, setFoundUser,
    guildCode, setGuildCode,
    isResultErrorsOpen, setIsResultErrorsOpen,
    rowsWithError, setRowsWithError,
    loadingField,
    setLoadingField,
    isNewDialogOpen, setIsNewDialogOpen,
    isSubmitting, setIsSubmitting,
    userContactInfo, setUserContactInfo,
    blockAccounts, setBlockAccounts,
    isLoadingBtn, setIsLoadingBtn,
    inquiryAccount, setInquiryAccount,
    blockedAccounts, setBlockedAccounts,
    itemNeed, setItemNeed,
    role, setRole,
    openBackDrop, setOpenBackDrop,
    setIsLoading,
    isLoading,
    selectedValue, setSelectedValue,
    openDialog, setOpenDialog,
    show, setShow,
    openSnack, setOpenSnack,
    cardInfoAcc, setCardInfoAcc,
    list, setList,
    isDisable, setDisable,
    saveNumber, setSaveNumber,
    loadingBtn, setLoadingBtn,
    methodType, setMethodType,
    size,
    setSize,
    loadingBtnAccept,
    setLoadingBtnAccept,
    loadingBtnIgnore,
    setLoadingBtnIgnore,
    dialog,
    setDialog,
    filterParams,
    setFilterParams,
    loading,
    setLoading,
    data, setData,
    selectedCheckData, setSelectedCheckData,
    productSearchText,
    setProductSearchText,
    newProductName,
    setNewProductName,
    currentProduct,
    setCurrentProduct,
    selectedProducts,
    setSelectedProducts,
    previewLoading,
    setPreviewLoading,
    previewData,
    setPreviewData,
    isOpenPreview,
    setIsOpenPreview,
    voucherHash,
    setVoucherHash,
    voucherHashs,
    setVoucherHashs,
    fileCounter,
    setFileCounter,
    filters,
    setFilters,
    loadingPage,
    setLoadingPage,
    isOpenExportDG,
    setIsOpenExportDG,
    isOpenTimetDG,
    setIsOpenTimetDG,
    timeRemain,
    setTimeRemain,
    isLoadingExport,
    setIsLoadingEport,
    isOpenTimeLineDg,
    setIsOpenTimeLineDg,
    dataTimeLine,
    setDataTimeLine,
    timeLineLength,
    setTimeLineLength,
    actionItems,
    setActionItems,
    changeOwner,
    setChangeOwner,
    submitLoading,
    setSubmitLoading,
    loadingStates,
    setLoadingStates,
    loadingCities,
    setLoadingCities,
    loadingUserInfo,
    setLoadingUserInfo,
    userSSOid,
    setUserSSOid,
    states,
    setStates,
    isShow,
    setIsShow,
    city,
    setCity,
    cities,
    setCities,
    provinceId,
    setProvinceId,
    formData,
    setFormData,
    selectedGuilds,
    setSelectedGuilds,
    guildSearchText,
    setGuildSearchText,
    firstLoad,
    setFirstLoad,
    defaultProvince,
    setDefaultProvince,
    accountDetails, setAccountDetails,
    defaultCity,
    setDefaultCity,
    page, setPage,
    province,
    setProvince,
    setCityId,
    isShowMessageLessLevel, setIsShowMessageLessLevel,
    grantTypeOptions,
    totalCount, setTotoalCount,
    stepData, setStepData,
    paramsData, setParamsData
  };
};

export default useCustomHook;
